import { slotThreadKey } from "./slot-thread";

interface ThreadRef {
  chatId: string;
  threadKey: string | null;
}

export type MessagesEntry =
  | { kind: "thread"; chatId: string; threadKey: string | null }
  /** No thread yet: the list, whose empty state offers the page's slot. */
  | { kind: "list" };

/**
 * Where the first Messages entry lands (owner ruling 2026-10-27): the visitor's last active thread;
 * never a new thread and never the page's slot thread (that is the launcher bubble's job).
 * The synthetic client placeholder (`chatId: ""`) is not a thread the visitor has.
 */
export function resolveMessagesEntry(
  /** The visitor's threads, most recently active first. */
  threads: readonly ThreadRef[],
): MessagesEntry {
  const last = threads.find((t) => t.chatId);
  return last
    ? { kind: "thread", chatId: last.chatId, threadKey: last.threadKey }
    : { kind: "list" };
}

export type NewConversation =
  /** The new conversation IS the page's slot thread (it does not exist yet): messageSlot on the first send. */
  | { kind: "slot-thread"; threadKey: string }
  /** The slot thread exists: a new regular thread that shows the slot text client-side only. */
  | { kind: "topic-with-slot-text"; slotId: string }
  | { kind: "plain" };

/** A conversation the visitor starts manually (Messages "new conversation") begins with the page's slot text. */
export function resolveNewConversation(
  top: { slotId: string; variantId: string } | null,
  threads: readonly ThreadRef[],
  keyFor: (slotId: string, variantId: string) => string = (s) => slotThreadKey(s),
): NewConversation {
  if (!top) return { kind: "plain" };
  const threadKey = keyFor(top.slotId, top.variantId);
  return threads.some((t) => t.chatId && t.threadKey === threadKey)
    ? { kind: "topic-with-slot-text", slotId: top.slotId }
    : { kind: "slot-thread", threadKey };
}
